import { Flex, Typography } from 'antd'
import { useTranslation } from 'react-i18next'

import { useStyles } from 'src/features/auth/styles'

const { Text } = Typography

export const QrCompactCaption = () => {
  const { t } = useTranslation()
  const { styles } = useStyles()

  return (
    <Flex vertical gap={6} align="center" className={styles.qrCompactCaption}>
      <Text strong className={styles.qrCompactTitle}>
        {t('auth.qrSignIn.title')}
      </Text>
      <Text className={styles.qrCompactDescription}>
        {t('auth.qrSignIn.subtitle')}
      </Text>
    </Flex>
  )
}
